<template>
  <AccordionCardInfoDisplay
    v-if="showForEntityTypes.includes(clickedEntityType)"
    :heading="title"
    :isExpanded="isExpanded"
    @onClicked="handleClick"
  >
    <template #content>
      <AccordionTable
        v-if="!isLoading && poisList.length"
        class="poi-summary"
        :titles="{ title1: t('general__text__category'), title2: t('general__data__quantity') }"
        :data="poisList"
        :firstColumnWide="true"
        :clickable="true"
        @toggleCategory="toggleCategory"
      />
      <div v-else-if="isLoading" class="loading-spinner">
        <PulseLoader :loading="true" color="#3F46D6" />
      </div>
      <div v-else class="no-data">
        <p>{{ t('general__data__no-data-published') }}</p>
      </div>
    </template>
  </AccordionCardInfoDisplay>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'
import { OVERVIEW_DATA } from '@/design-system/molecules/AccordionTable.vue'
import { SummaryObject, SummaryType } from '@/interfaces/summary.interface'
import AccordionCardInfoDisplay from '@/components/features/info-display/AccordionCardInfoDisplay.vue'
import AccordionTable from '@/design-system/molecules/AccordionTable.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

const props = defineProps<{
  isLoading: boolean
  poiSummaryData: SummaryObject[]
  showForEntityTypes: string[]
  title: string
}>()

const selectionStore = useSelectionStore()

const { t } = useI18n()
const { clickedEntityType } = storeToRefs(selectionStore)

const isExpanded = ref(false)
const poisList = ref<any[]>([])

function generatePoisList(poiData: SummaryObject[]) {
  let poisArray: any[] = []
  if (!poiData?.length) {
    poisList.value = poisArray
    return
  }
  poisArray = props.poiSummaryData.map((object: SummaryObject) => {
    const types = object.types.map((item: SummaryType) => {
      return {
        color: item.color,
        value1: item.typeName,
        value2: item.count
      }
    })
    const mappedObject: OVERVIEW_DATA = {
      id: object.id ?? object.categoryId,
      value1: object.categoryName,
      value2: object.count,
      items: types,
      visible: true
    }
    return mappedObject
  })
  poisList.value = poisArray
}
function toggleCategory(id: string) {
  poisList.value.map((item: any) => {
    if (item.id === id) {
      item.visible = !item.visible
    }
    return item
  })
}
function handleClick() {
  isExpanded.value = !isExpanded.value
}

watch(
  () => props.poiSummaryData,
  (newData) => {
    generatePoisList(newData)
  }
)
</script>
<style scoped lang="scss">
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
.poi-summary {
  overflow: hidden;
  flex: 1 1 auto;
  height: fit-content;
  z-index: 1;
  width: 100%;
  padding-top: 4px;
}
.loading-spinner {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.no-data {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    @include font-mixins.desktop-regular-label;
  }
}
</style>
